import api from "./axios";

class ServiceInspection {
  async save(inspection, files = []) {
    const formData = new FormData();
    formData.append("inspection", JSON.stringify(inspection));
    files.forEach((file) => {
      formData.append("files", file);
    });
    const { data } = await api.post("/inspections", formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return data.id;
  }

  async update(inspection, files = []) {
    const formData = new FormData();
    formData.append("inspection", JSON.stringify(inspection));
    files.forEach((file) => {
      formData.append("files", file);
    });
    await api.put(`/inspections/${inspection.id}`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  }

  async updateStatus(id, status) {
    await api.patch(`/inspections/${id}/status`, { status });
  }

  async linkRecipe(id, recipe) {
    await api.patch(`/inspections/${id}/recipe`, recipe);
  }

  async delete(id) {
    await api.delete(`/inspections/${id}`);
  }

  async findById(id) {
    const { data } = await api.get(`/inspections/${id}`);
    return data;
  }

  async findAll(params) {
    const { data } = await api.get("/inspections", { params });
    return data;
  }

  async dashboard(month) {
    const { data } = await api.get("/inspections/dashboard", {
      params: { month },
    });
    return data;
  }

  async dashboardMileage(month) {
    const { data } = await api.get("/inspections/dashboard/mileage", {
      params: { month },
    });
    return data;
  }

  async findHistory(customerId) {
    const { data } = await api.get("/inspections", {
      params: { customerId, page: 1, limit: 100 },
    });
    return data.data || [];
  }

  async calculateTravelDistance(id) {
    const { data } = await api.get(`/inspections/${id}/travel-distance`);
    return data;
  }

  print(id) {
    const token = localStorage.getItem("token");
    window.open(
      `${process.env.VUE_APP_URL_BACKEND}/inspections/${id}/print?auth=${token}`
    );
  }
}

export default new ServiceInspection();
